import { ColumnMetadata, ColumnTypes } from "~/components/DataGrid";
import { Asset, AssetColumns } from "~/modules/assets/types";
import { Emdash } from "~/components/Punctuation";
import { AssetTableRowData } from "../types";

// // // //

export const MINIMUM_REDEMPTION_AMOUNT: ColumnMetadata<
    AssetTableRowData,
    AssetColumns
> = {
    slug: "Minimum Redemption Amount",
    label: "Minimum Redemption Amount",
    type: ColumnTypes.string,
    width: 180,
    render: (item) => {
        if (item.isAsset) {
            const asset = item as Asset;
            const primaryCurrency =
                asset.primary_market?.base_asset_ticker ?? null;
            const value =
                asset.primary_market?.redemption_minimum_amount ?? null;

            if (typeof value !== "number") {
                return <Emdash />;
            }

            if (!primaryCurrency) {
                return `${value.toLocaleString()}`;
            }

            return `${value.toLocaleString()} ${primaryCurrency}`;
        }

        return <Emdash />;
    },
};
